export const SET_EMAIL: string = "SET_EMAIL";
export const SET_PASSWORD: string = "SET_PASSWORD";
export const GET_TOKEN: string = "GET_TOKEN";
export const LOGOUT: string = "LOGOUT";
